import { createSlice } from '@reduxjs/toolkit'
import { posts } from './mockData'
import { actions } from '@storybook/addon-actions'
import { normalize, schema } from 'normalizr'

export const BlogStatus = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

const initialState = {
    posts: [],
    status: BlogStatus.LOADING,
    errorMessage: null,
    paging: {
        pageNo: 1,
        pageSize: 10,
        pageCount: 1,
        totalRecordCount: 1,
    },
}

const blogPostSchema = new schema.Entity(
    'posts',
    {},
    {
        idAttribute: 'postId',
    }
)

const blogSlice = createSlice({
    name: 'blog',
    initialState,
    reducers: {
        getPostsRequest: state => {
            state.status = BlogStatus.LOADING
        },
        getPostsRequestSuccess: (state, action) => {
            const { posts, paging } = action.payload
            state.posts = posts
            state.status = BlogStatus.SUCCESS
            state.paging = paging
        },
        getPostsRequestFailure: (state, action) => {
            state.errorMessage = action.payload.error
            state.status = BlogStatus.FAILURE
        },
        resetPosts: state => {
            state.posts = []
            state.status = BlogStatus.LOADING
            state.paging = {
                pageNo: 1,
                pageSize: 10,
                pageCount: 1,
                totalRecordCount: 1,
            }
        },
    },
})

const {
    getPostsRequestSuccess,
    getPostsRequestFailure,
    getPostsRequest,
    resetPosts,
} = blogSlice.actions

export const blogActions = {
    getPostsRequestSuccess,
    getPostsRequestFailure,
    getPostsRequest,
    resetPosts,
}

export const blogSelectors = {
    getPostsState: state => state.blog.posts,
    getIsFetchingState: state => state.blog.status === BlogStatus.LOADING,
    getErrorState: state => state.blog.errorMessage,
    getPagingState: state => state.blog.paging,
}

export default blogSlice.reducer
